import { render, staticRenderFns } from "./CRMAllCreate.vue?vue&type=template&id=201517fc&scoped=true"
import script from "./CRMAllCreate.vue?vue&type=script&lang=js"
export * from "./CRMAllCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201517fc",
  null
  
)

export default component.exports